// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".saas_remind .icon[data-v-310fe614] {\n  border-radius: 0.375rem;\n  border: 0.0625rem solid #e7ecf1;\n  margin-top: 0.625rem;\n  overflow: hidden;\n}\n.saas_remind .title .tips[data-v-310fe614] {\n  color: #999;\n  margin-left: 0.3125rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
